"use strict";
import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

const MODAL_OPEN_CLASS = 'body--modal-open';

import classNames from 'classnames';

export default class SubmitModal extends React.PureComponent {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        closeText: PropTypes.string,
        submitText: PropTypes.string,
        header: PropTypes.string,
        confirmationQuestion: PropTypes.string,
        displayWarnIcon: PropTypes.bool,
        firstLevelModal: PropTypes.bool,
        isSubmitDisabled: PropTypes.bool,
        isSubmitVisible: PropTypes.bool,
        modalClassName: PropTypes.string,
        isCloseDisabled: PropTypes.bool
    };

    static defaultProps = {
        closeText: 'Cancel',
        submitText: 'Submit',
        header: 'Please Confirm',
        confirmationQuestion: 'Are you sure you want to continue?',
        displayWarnIcon: true,
        firstLevelModal: true,
        isSubmitDisabled: false,
        isSubmitVisible: true,
        modalClassName: '',
        isCloseDisabled: false
    };

    componentDidMount() {
        if (this.props.firstLevelModal) {
            document.body.classList.add(MODAL_OPEN_CLASS);
        }
    }

    componentWillUnmount() {
        if (this.props.firstLevelModal) {
            document.body.classList.remove(MODAL_OPEN_CLASS);
        }
    }

    render() {
        const {
            onClose,
            onSubmit,
            children,
            submitText,
            closeText,
            header,
            confirmationQuestion,
            displayWarnIcon,
            isSubmitDisabled,
            isSubmitVisible,
            modalClassName,
            isCloseDisabled
        } = this.props;
        const modalClassNames = classNames('flex-submit-modal', modalClassName);
        return (
            <Modal.Dialog className={modalClassNames}>
                <div className="flex-submit-modal__header">
                    <div className="flex-submit-modal__header-title-container">
                        {displayWarnIcon && (
                            <div className="flex-submit-modal__header-title-icon">
                                <i className="fa fa-exclamation-triangle" />
                            </div>
                        )}

                        <div className="flex-submit-modal__header-title">{header}</div>
                    </div>

                    <a className={classNames("flex-submit-modal__header-close", {"disabled": isCloseDisabled})} onClick={onClose}>
                        <i className="fa fa-close" />
                    </a>
                </div>

                <div className="flex-submit-modal__delimiter" />

                <div className="flex-submit-modal__content">
                    {children && (
                        <div className="flex-submit-modal__content-you-are-about">{children}</div>
                    )}

                    {!!confirmationQuestion && (
                        <p className="flex-submit-modal__are-you-sure">{confirmationQuestion}</p>
                    )}

                    <div className="flex-submit-modal__content-buttons">
                        <a className={classNames("flex-submit-modal__cancel", {"disabled": isCloseDisabled})} onClick={onClose}>
                            {closeText}
                        </a>
                        {isSubmitVisible && (<button
                            className="btn flex-submit-modal__submit"
                            onClick={onSubmit}
                            disabled={isSubmitDisabled}
                        >
                            {submitText}
                        </button>)} 
                    </div>
                </div>
            </Modal.Dialog>
        );
    }
}
